/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./applicationsList.vue?vue&type=template&id=4537234e"
import script from "./applicationsList.vue?vue&type=script&lang=js"
export * from "./applicationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports